import { Component, OnInit,ViewChild,TemplateRef,HostListener, ElementRef, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subscription,Observable } from 'rxjs';
import { PlayersService as PlayerService } from '../resultboard/draft/players/players.service';
import { UtilsService } from '../_services/utils.service'
import { RankemService } from '../_services/rankem.service';
import { LeagueRegPopupComponent } from './../league-reg-popup/league-reg-popup.component';
import { MainService } from 'src/app/_services/main.service';
import { ActivatedRoute, Router, Event, NavigationStart } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TournamentService } from './../tournamentpopup/tournament.service';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { SortablejsOptions } from 'angular-sortablejs';
import { TournamentpopupComponent } from './../tournamentpopup/tournamentpopup.component';
import { GamepreviewpopupComponent } from './../gamepreviewpopup/gamepreviewpopup.component';
import { ComponentCanDeactivate, UnSavedGuard } from '../_guards/'
import { MatTabGroup } from '@angular/material';

@Component({
selector:'app-rankem',
templateUrl:'./rankem.component.html',
styleUrls:['./rankem.component.scss']
})


export class RankemComponent implements ComponentCanDeactivate,OnInit{
    sub_isMobileScreen: Subscription;
    isMobile = false;
    subPlayersServiceData: Subscription;
    sublgDetail: Subscription;
    games = {
      0: 'all',
      1: 'nhl',
      2: 'nfl',
      3: 'mlb',
      4: 'nba',
      5: 'pga'
    };
    myTeam = [];
    visibleQuickJoin = false;
    quickContests = [];
    teamfilter:string;
    isMyTeam=true;
    orderChnage=false;
    disableButton=false;
    mode='create';
    multiplier='';
    curSort = '';
    curDir = 1;
    playerData:any;
    playerList:any;
    errors="";
    selectedteam=0;
    successMsg = "";
    joinLeagueData:any;
    searchString='';
    currentUser:any;
    loginUserID:number;
    searchTimer = null;
    showfpts=false;
    newTeam = false;
    isLoading=true;
    roster_positions:any;
    uploadURL = `${environment.assetUploadURL}`+'/players/';
    total_number=0;
    player_remainig = 0;
    baseURL = `${environment.SITE_URL}`;
    bucketURL = `${environment.assetURL}`+'/assets/default/images/';
    rankemData:any;
    league_member_id=0;
    game_type:string;
    parameters = {game_type:null,league_id: null, lgm_id: null};
    lgm_id = 0;
    user: any = null;
    leagueDialogRef: MatDialogRef<LeagueRegPopupComponent>;
    confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
    selectedPlayers = [];
    eventOptions: SortablejsOptions = {
    handle: '.myTmDeta',
    onEnd: (e)=>{
      this.orderChnage = true;
      let aa =this.immutableMove(this.selectedPlayers,e.oldIndex,e.newIndex);
      this.checkDisabled();
    }
  };
  showPlayersTab = true;
  curTabClass='players';
  curTab='players';
  darkMode= false;
  darkMode_ext = '';
  dialogRef2:any;
  currentLgmId=0;
  @ViewChild("limitDiv") limitDiv: MatTabGroup;
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    this.isLoading=false;
    return !this.orderChnage;
  }
  @ViewChild('quickJoin') quickJoin: TemplateRef<any>;
  @ViewChild('playerrowele') playerrowele: ElementRef<any>;
  @ViewChild('activeDraftElement') ade: ElementRef<any>;
    constructor(private spinner:NgxSpinnerService,private _mainService: MainService,private tournamentService: TournamentService,private PlayersService: PlayerService,private rankemService:RankemService, public dialog: MatDialog,private _utilsService:UtilsService, private store: Store<any>,private route: ActivatedRoute,private router: Router){
      this.spinner.hide();
      this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
        if (state.length > 0) {
          this.isMobile = state[0];
        }
      });
      this.store.select('DarkModeReducer').subscribe(state => {
        if (state.length > 0) {
          this.darkMode = state[0].isDarkMode;
          this.darkMode_ext = this.darkMode?'-dark':'';
        }
      });
    }
    ngOnInit(){
    this.isLoading = true;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser !== null) {
     this.loginUserID = parseInt(this.currentUser.id);
     this.route.params.subscribe(params => {
      this.parameters.league_id = params.league_id;
      this.parameters.game_type = params.game_type;
      this.parameters.lgm_id = (params.lgm_id != null) ? params.lgm_id : 0;
      if (this.parameters.lgm_id == 0) this.newTeam = true;
      if(!this.isNumeric(this.parameters.league_id) || !this.isNumeric(this.parameters.lgm_id)){
        this.router.navigate(['/lobby']);
      }
      this.selectedteam = parseInt(this.parameters.lgm_id);
        this.getLeagueDetail(); 
    });
    }
    if (localStorage.getItem('currentUser') == null){
      // redirect to login page
      window.location.href = `${environment.SITE_URL}`+ '/logout';
    }
    
    }
 getLeagueDetail(){
  this.isLoading = true;
  this.rankemService.getLeagueDetail(this.parameters.league_id,this.loginUserID,this.parameters.lgm_id).subscribe(res => {      
    this.selectedPlayers= [];
    if(res.status==0){
      this.router.navigate(['/lobby']);
    }
    this.rankemData = res.entities;
    if (this.parameters.lgm_id != 0) {
      let invalid = true;
      if(this.rankemData.standing.length<=0){
        this.rankemData.myTeams.filter(contest => {
          if (contest.id == this.parameters.lgm_id) {
            invalid = false;
          }
        });
      } else {
        this.rankemData.standing.filter(stand => {
          if (stand.lgm_id == this.parameters.lgm_id) {
            invalid = false;
          }
        });
      }
      
      if (invalid) {
        this.router.navigate(['/lobby']);
      }
    }
    if(this.rankemData){
      this.playerList = this.rankemData.players;
    }
    this.game_type =this.rankemData.league.lg_abbr;
    this.total_number =this.rankemData.total_player;
    this.player_remainig = this.rankemData.total_player;
    this.showfpts = this.rankemData.league.egs < Math.floor(Date.now()/1000)?true:false;
    if(this.showfpts || this.parameters.lgm_id>0){
      this.newTeam = false;
    }
    if(this.showfpts && !this.parameters.lgm_id){
      let data = {'value':this.rankemData.myTeams[0].id};
      this.changeTeam(data);
    }
    if(this.parameters.lgm_id>0){
      this.selectedPlayers = [...this.rankemData.ranked_player];
    }
    this.showMultiplier();
    this.checkDisabled();   
    this.isLoading = false;
    }); 
    
 }    
  getInjuryAbbr(desc) {
    switch (desc) {
      case 'Out':
        return 'O';
      case 'Day-To-Day':
        return 'Q';
      case 'IR':
        return 'O';
      case 'IR-NR':
        return 'O';
      case 'IR-LT':
        return 'O';
      case 'QUESTIONABLE':
        return 'Q';
      case 'DOUBTFUL':
        return 'O';
      case 'OUT':
        return 'O';
      case 'INACTIVE':
        return 'O';
      case 'PUP-R':
        return 'O';
      case 'PUP-P':
        return 'O';
      case 'IR-R':
        return 'O';
      case 'IR':
        return 'O';
      case 'RESERVE-DNR':
        return 'O';
      case 'NFI-R':
        return 'O';
      case 'NFI-A':
        return 'O';
      case 'RESERVE-CEL':
        return 'O';
      case 'RESERVE-SUS':
        return 'O';
      case 'RESERVE-RET':
        return 'O';
      case 'RESERVE-EX':
        return 'O';
      case 'RESERVE-COVID-19':
        return 'O';
      case 'GTD':
        return 'D';
      case 'OUT':
        return 'O';
      case 'OFS':
        return 'O';
      case '60-Day IL':
        return 'O';
      case '15-Day IL':
        return 'O';
      case '10-Day IL':
        return 'O';
      case 'Out':
        return 'O';
      case '7-Day IL':
        return 'O';
      case 'Suspension':
        return 'O';
      case 'Paternity':
        return 'O';
      case 'Bereavement':
        return 'O';
      case 'COVID-19':
        return 'O';
      default:
        return desc.charAt(0);
    }
  }
  
    filterStandings = (user: any) => {
    const regex = new RegExp(this.searchString,'gi');
    return (user.team_name.match(regex) != null);
  }

  filterPlayers = (player: any) => {
    if (this.searchString != '' && this.teamfilter!=''){
      const regex = new RegExp(this.searchString,'gi');
      const teamfregex = new RegExp(this.teamfilter,'gi');
      let fullName = player.fn+' '+player.ln; 
      return ((player.fn.match(regex) != null || player.ln.match(regex) != null || fullName.match(regex)!=null) && player.tn.match(teamfregex)!=null);
    } else if (this.searchString != '' && this.teamfilter==''){
      const regex = new RegExp(this.searchString,'gi');
      let fullName = player.fn+' '+player.ln; 
      return (player.fn.match(regex) != null || player.ln.match(regex) != null || fullName.match(regex)!=null);
    }else if (this.searchString == '' && this.teamfilter!=''){
      const teamfregex = new RegExp(this.teamfilter,'gi');
      return (player.tn.match(teamfregex)!=null);
    }else{
      return player;
    }
  }
  
  openInfo(player, player_id, e) {
    e.preventDefault();
    e.stopPropagation();
    if ((player.infobox == null || player.infobox == 1) && player_id) {
      let filterddata = this.playerList.filter((player)=>this.filterPlayers(player));
      const playername = player.fn?player.fn+' '+player.ln:player.pname.split(" ");
      this.dialog.open(Playerinfobox2Component, {
        width: this.isMobile?'90%':'70%',
        height: 'auto',
        autoFocus: false,
        data: {
          isDraft: false,
          league: {
            game_id: this.rankemData.league.game_id,
            id: this.rankemData.fantasy_lg_id,
            abbr: this.rankemData.league.lg_abbr,
            active_season_id: this.rankemData.league.season_id
          },
          lgm_id: 0,
          players: filterddata,
          player_data : {'pp' : player.pp?player.pp:player.plrImage, 'fn' : player.fn?player.fn:playername[0], 'ln' : player.ln?player.ln:playername[1]},
          player_id
        }
      });
    }
  }
  
  selectPlayer(player){
    const found = this.rankemData.ranked_player.some(el => el.id == player.id);
    if(found==true){
      player.is_hide = 1;
    }
    this.orderChnage = true;
    for (let i=0;i<this.rankemData.ranked_player.length;i++){
      const slot = this.rankemData.ranked_player[i];
      if (slot.id == 0 && found==false){
        slot.id = parseInt(player.id);
        slot.proj = player.prj;
        slot.fpts = player.gp > 0?(player.fpts / player.gp):player.fpts;
        slot.avg = player.gp > 0?(player.fpts / player.gp):player.fpts;
        slot.tid = player.tid;
        slot.pname = player.fn + ' ' + player.ln;
        slot.plrImage = this.uploadURL+player.pp
        slot.gp_id = player.pid;
       // slot.display_pn = slot.display_pn==undefined?slot.pn:slot.display_pn;
        //slot.pn = slot.pnMulti;
        slot.pick_rp = player.pn;
        slot.opn = player.opn;
        slot.start_time = player.form_gs;
        slot.tn = player.tn;
        player.is_hide = 1;
        this.player_remainig--;
        this.selectedPlayers.push(slot);
        //this.selectedPlayers.splice(i, 0, slot);
        break;
      }
    }
    this.checkDisabled();
    if(this.player_remainig==0 && this.selectedteam==0){
      this.joinLeaguePopup();
    }
    this.showMultiplier();   
    
  }
  
  getLastName(player){
    let temp = player.pname.split(' ');
    temp.splice(0,1);
    return temp.join(' ');
  }

  joinLeaguePopup(league = null, isQuickJoin = false) {
    this.disableButton =true;
    setTimeout(()=>{
      this.disableButton =false;
    },2000);
    this.orderChnage = false;
    if(this.selectedteam>0){
      this.sendRoster(this.rankemData.league, this.selectedteam);
      return true;
    }
    this.errors = '';
    if (league == null) league = this.rankemData.league;
    if(Number(league.entrants) - Number(league.joined_entrants)<=0){
      this.errors = 'League is already full';
      return false;
    } else if(this.rankemData.myTeams.length>=league.max_entries){
      this.errors = 'You have already entered this contest with the maximum number of entries';
      return false
    }
    this.tournamentService.getUserLocation(this.currentUser.id, locationData => {
      locationData['league_code'] = league.league_code;
      locationData['user_id'] = this.currentUser.id;
      this.sublgDetail = this.tournamentService.getJoinPopUpData(locationData).subscribe(res => {
        if (typeof res !== 'undefined' && res.status === 'success') {
          this.joinLeagueData = res.entities;
          if(this.joinLeagueData && (Number(this.joinLeagueData.balance) < Number(this.joinLeagueData.league_fee)) && (!this.joinLeagueData.hasTicket)){
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: '500px',
              data: { 'title': "Deposit", 'body': '','type':'deposit_fee','league_type':league.league_type?league.league_type:league.lg_abbr,'name':league.name,'balance_text':this.joinLeagueData.balance_text,'entry_fee':this.joinLeagueData.entry_fee }
            });
            
            this.confirmDialogRef.afterClosed()
            .subscribe(res => {
            })
          }else{
            const remaining_people = Number(league.entrants) - Number(league.joined_entrants);
            this.leagueDialogRef = this.dialog.open(LeagueRegPopupComponent, {
              width: '500px',
              data: { 'league_code': league.league_code, 'draft_type': 'rankem', 'result':this.joinLeagueData, 'remaining_people':remaining_people, 'drafttype_id':5 }
            });
        
            this.leagueDialogRef.afterClosed()
            .subscribe(res => {
              if (res.status == 'success'){
                if(isQuickJoin){
                this.quickContests.filter(contest => {
                  if(contest.id==league.id){
                    contest.is_joined = 1;
                  }
                });
                this.newTeam =false;
               }
               this.currentLgmId = res.my_team_id;
                this.sendRoster(league, res.my_team_id);
                
              } 
            })
          }
        }
        else {
          this.isLoading = false;
          this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: (res.type == 'age_18') ? '500px' : '800px',
              data: { 'title': "Eligibility Warning", 'body': res.message,'type':res.type }
            });
            
            this.confirmDialogRef.afterClosed()
            .subscribe(res => {
              if (res) {
               
              }
            })
        }
      });
    });
  }

  sendRoster(league = null, lgm_id = null){
    this.errors = '';
     this.isLoading = true;
    if (league.egs == null) league.egs = parseInt(league.pro_game_start_time);
    if (this.player_remainig == 0 && this.isMyTeam && lgm_id > 0 && league.egs > Math.floor(Date.now()/1000)){
      let soreted_arr = this.roasterFix();
      let league_id = league.id;
      if(league.tournament_code!=undefined && league.tournament_code!=""){
        league_id = league.league_id;
      } 
    
      this._mainService.saveRankemRoster(league_id,lgm_id,league.game_id,soreted_arr).subscribe(state => {
        this.orderChnage = false;
        if (state.status == 'success'){
          this.successMsg = state.message;
           if (this.newTeam){
             this.showQuickJoin();
           }
          if (league.my_entries != null) league.my_entries++;
          league.joined_entrants = parseInt(league.joined_entrants)+1;
          setTimeout(() => {
            this.successMsg = "";
          }, 5000);
        } else {
          this.errors = state.message;
          setTimeout(() => {
            this.errors = "";
          }, 5000);
          
        }
        this.isLoading = false;
        if (!this.newTeam && this.visibleQuickJoin==false){
          let data = {'value':lgm_id};
          this.changeTeam(data);
        }
      });
    } else {
      if (lgm_id == 0) this.errors = 'You haven\'t properly entered the contest yet.';
      if (!this.isMyTeam) this.errors = 'You don\'t own the team you\'re trying to edit.';
      if (this.mode != 'create' || this.rankemData.league.egs <= Math.floor(Date.now()/1000)) this.errors = 'The contest has already started.';
      if (this.rankemData.remaining > 0) this.errors = 'You are trying to submit an incomplete team.';
    }
  }
  
  setSearch(event){
    if(typeof event.value){
      this.teamfilter = event.value;
    }
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.searchString = event.target.value;
    },800);
  }
  
  clearSearch(){
    
      this.searchString = '';
    
  }
  
  removePlayer(player,event){
    event.stopPropagation();
    const playerid = player.id;
    for (let i=0;i<this.rankemData.players.length;i++){
      if (this.rankemData.players[i].id == player.id){
        this.rankemData.players[i].is_hide = 0;
        break;
      }
    }
    this.orderChnage = true;
    this.selectedPlayers.splice(this.selectedPlayers.findIndex(e => e.id == playerid),1);
    player.pname = 'Select player';
    player.id = 0;
    player.proj = 0;
    player.tid = 0;
    player.plrImage = '';
    player.gp_id = 0;
    // player.pn = player.display_pn;
    // player.display_pn = null;
    player.is_hide =0;
    this.player_remainig++;
    //this.rankemData.multiplier++;
    
    this.showMultiplier();
    this.checkDisabled();
  }
  array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }
  immutableMove(arr, from, to) {
    return arr.reduce((prev, current, idx, self) => {
      if (from === to) {
        prev.push(current);
      }
      if (idx === from) {
        return prev;
      }
      if (from < to) {
        prev.push(current);
      }
      if (idx === to) {
        prev.push(self[from]);
      }
      if (from > to) {
        prev.push(current);
      }
      return prev;
    }, []);
  }
 
  sortPlayers(type){
    if (this.curSort == type) this.curDir = this.curDir*-1;
    this.curSort = type;
    switch(type){
      case 'pos':
        this.playerList.sort((a,b)=>{
          return (parseFloat(a.pn) < parseFloat(b.pn))?1*this.curDir:-1*this.curDir;
        });
        break;
      case 'fpts':
        this.playerList.sort((a,b)=>{
          return (parseFloat(a.fpts) < parseFloat(b.fpts))?1*this.curDir:-1*this.curDir;
        });
        break;
      case 'proj':
        this.playerList.sort((a,b)=>{
          return (parseFloat(a.proj) < parseFloat(b.proj))?1*this.curDir:-1*this.curDir;
        });
        break;
      case 'fn':
        this.playerList.sort((a,b)=>{
          return (a.fn+' '+a.ln < b.fn+''+b.ln)?1*this.curDir:-1*this.curDir;
        });
        break;
    }
  }
  changeTeam(event){
    if (parseInt(event.value) > 0){
      this.newTeam = false;
    } else {
      this.newTeam = true;
    }
    this.isLoading = true;
    this.selectedteam = parseInt(event.value);
    this.router.navigate(['/rankem/'+this.game_type+'/'+this.parameters.league_id+'/'+event.value]);
    this.isLoading = false;
  }
  getPositionBG(position){
    position = position.split(",")[0];
		var colors = {
			"QB":"#bac9e2",
			"RB":"#bae2ba",
			"WR":"#e2e1ba",
			"TE":"#e2baba",
			"DEF":"#bae2e0",
			"K":"#d8bae2", 
			"FLEX":"rgba(146, 134, 44)", 
			"C":"rgba(207, 93, 41)",
			"LW":"rgba(72, 175, 23)",
			"RW":"rgba(207, 189, 22)",
			"D":"rgba(71, 170, 162)",
			"G":"rgba(189, 23, 23)",
			"1B":"rgba(84, 45, 224)",
			"2B":"rgba(72, 179, 23)",
			"3B":"rgba(207, 189, 22)",
			"SS":"rgba(223, 27, 27)",
			"LF":"rgba(32, 180, 155)",
			"CF":"rgba(155, 32, 167)",
			"RF":"rgba(187, 38, 120)",
			"SP":"rgba(76, 153, 147)",
			"TG":"rgba(74, 79, 136)",
			"BN":"rgba(58, 131, 119)",
			"IR":"rgba(51, 109, 63)",
			"W":"rgba(167, 94, 46)",
			"F":"rgba(150, 56, 90)",
			"S":"rgba(54, 131, 33)",
			"MI":"rgba(60, 82, 54)",
			"OF":"rgba(148, 77, 139)",
			"DH":"rgba(97, 42, 56)",
			"UTIL":"rgba(70, 148, 148)",
			"P":"rgba(101, 131, 76)",
			"RP":"rgba(120, 155, 39)",
			"PG":"rgba(136, 34, 34)",
			"FG":"rgba(104, 134, 28)", 
			"SG":"#8ae06b",
			"SF":"rgba(37, 50, 172)",
			"PF":"rgba(106, 39, 131)",
			"WR-TE":"#ff76149e"	
		};
		if (typeof colors[position] != "undefined"){
			return colors[position];
		} else {
			return "#FFF";
		}
	}
  
  openLeague(league_id, tournament_id): void {
    let dialogRef = null;
    if (tournament_id == 0) {
      dialogRef = this.dialog.open(GamepreviewpopupComponent, {
        width: '800px',
        data: { league_id,'pagename':'rankem' },
        autoFocus: false
      });
    } else {
      dialogRef = this.dialog.open(TournamentpopupComponent, {
        width: '800px',
        data: {
          league_id,
          tournament_id
        },
        autoFocus: false
      });
    }

    dialogRef.afterClosed().subscribe(result => {
       if(result!=undefined && result.route!=undefined)
       this.router.navigate(result.route);
    });
    dialogRef.componentInstance.closePopupAndNavigate.subscribe((route) => {
    dialogRef.close({'route':[route]})
    });
    
  }
  playerDisplay(player){
    if(player.is_hide==1){
      return false;
    }else{
      const found = this.rankemData.ranked_player.some(el => el.id == player.id);
      if(found==true){
        player.is_hide = 1;
      }
      return !found;
    }
  }
  roasterFix(){
    let element = this.playerrowele.nativeElement;
        let children = element.children;
        let rplen = this.rankemData.ranked_player.length;
        if(rplen!=this.selectedPlayers.length){
          this.errors = 'Please selecte all players';
          return false;
        }
        let ordered_roasterarray = [];
        for(var i=0; i<children.length; i++){
            let player_id = children[i].dataset.player_id;
            this.selectedPlayers.filter(player => {
              if(player.id==player_id){
                let ordered_roaster = {...player};
                ordered_roaster.id = player.id;
                ordered_roaster.pick_rp = player.pick_rp;
                ordered_roaster.fpts = player.fpts;
                ordered_roaster.avg = player.avg;
                ordered_roaster.proj = player.proj;
                ordered_roaster.pname = player.pname;
                ordered_roaster.plrImage = player.plrImage;
                ordered_roaster.gp_id = player.gp_id;
                ordered_roaster.pn = i<rplen-2?i+1:'R';
                ordered_roasterarray.push(ordered_roaster);
              }
            })
        }
    return ordered_roasterarray;
  }
  showMultiplier(){
    this.multiplier='';
    for (let i=0;i<this.rankemData.ranked_player.length;i++){
      const slot = this.rankemData.ranked_player[i];
      if (slot.id == 0){
        this.multiplier  = slot.pnMulti;
        break;
      }
    }
  }
  isNumeric(num) {
    return (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num as any);
  }
  checkDisabled(){
    if (this.player_remainig > 0 || this.rankemData.league.egs < Math.floor(Date.now()/1000)){
      this.disableButton= true;
    }else{
      if(this.orderChnage)
       this.disableButton = false;
       else
       this.disableButton = true;
    }
  
  }
  
  showQuickJoin(){
    this._mainService.rankemQuickJoin(this.rankemData.league.lg_abbr, this.rankemData.position_set, this.loginUserID).subscribe(state => {
      if (state.status == 'success' && (state.entities.tournamentList.length || state.entities.contestList.length)){
        state.entities.tournamentList.forEach(contest => {
          contest.my_entries = (contest.league_joined_users != null)?contest.league_joined_users.split(',').filter(user => parseInt(user) ==this.loginUserID).length:0;
          contest.confirm = 0;
        });
        state.entities.contestList.forEach(contest2 => {
          contest2.my_entries = (contest2.league_joined_users != null)?contest2.league_joined_users.split(',').filter(user => parseInt(user) ==this.loginUserID).length:0;
          contest2.confirm = 0;
        });

        const allcontests = state.entities.tournamentList.concat(state.entities.contestList);
       // const allcontests = state.entities.contestList;
        if (allcontests.length){
          this.quickContests = allcontests;
          this.visibleQuickJoin = true;
          this.dialogRef2 = this.dialog.open(this.quickJoin);
          this.dialogRef2.afterClosed().subscribe(result => {
                if (result !== undefined) {
                    if (result.close == 'yes') {
                      this.router.navigate(['/rankem/'+result.league_type+'/'+result.id+'/0']);
                    } else if (result === 'no') {
                        this.router.navigate(['/lobby']);
                    }
                } else {
                  this.router.navigate(['/lobby']);
                }
            })
        } 
      }else{
        this.router.navigate(['/rankem/'+this.rankemData.league.lg_abbr+'/'+this.parameters.league_id+'/0']);
      }
    });
  }
  
  quickJoinProcess(contest){
    contest.confirm = (contest.confirm == 0) ? 1 : 0; // 2-step join confirmation
    if (!contest.confirm){
      this.joinLeaguePopup(contest, true);
    }
  }

  redirect(contest){
    if(contest.id!=this.parameters.league_id){
      this.isLoading = true;
    }
    let league_id = contest.id;
      if(contest.tournament_code!=undefined && contest.tournament_code!=""){
        league_id = contest.league_id;
      } 
    let data = {'close':'yes','league_type':contest.league_type,'id':league_id};
   this.dialogRef2.close(data);
   this.visibleQuickJoin = false;
  }
  selectStanding(lgm_id){
    this.router.navigate(['/rankem/'+this.game_type+'/'+this.parameters.league_id+'/'+lgm_id]);
    this.curTabClass='myteam';
    this.curTab='myteam';
    this.tabChange('0');
  }

  tabChange(tab) {
    const tabGroup = this.limitDiv;
    if(tab!='null')
      this.goToSpecificTabIndex(tab);
    if(tabGroup.selectedIndex == 1) {
    }
  }

  goToSpecificTabIndex(currentTab){
    const tabGroup = this.limitDiv;
    if (!tabGroup || !(tabGroup instanceof MatTabGroup)) return;
    if(tabGroup.selectedIndex != currentTab) {
      tabGroup.selectedIndex = currentTab;
    }
  }
  getClassName(){
    let elementh = this.ade.nativeElement.offsetHeight;
    return elementh>1?true:false;
  }
} 